module.exports = __webpack_public_path__ + "static/media/phone.03b73130.svg";